import NetworkRequestGenerator from "../NetworkRequestGenerator";
import NetworkRequestDescriptor from "../../models/NetworkRequestDescriptor";
import {Device} from "../../models/Device";
import ApiKey from "../../models/ApiKey";
import DeviceProfile from "../../models/DeviceProfile";
import DataConverter from "../../models/DataConverter";
import SigV4 from "@/utils/SigV4";
import {resolve} from "core-js/fn/promise";

export default class AWS extends NetworkRequestGenerator {
  constructor(context, settings) {
    super();
    this.context = context;
    this.settings = settings;
    this.sigv4 = new SigV4();
  }

  EnableAppCommunication() {
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "PATCH",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/data",
      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "PATCH",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/data",
      headers,
      "",
      ""
    );
  }

  AddDevice(device) {
    let device_id = device.device_id;
    let body = {
      device_id: device_id, //device.id,
      label: device.label,
      device_type: device.technology,
      device_profile: device.deviceProfile,
    };
    body[device.technology] = {
      technology: device.technology,
      region: device.region,
      application_id: device.applicationId,
      application_eui: device.applicationEui,
      application_key: device.applicationKey,
      api_key: device.apiKey,

      name: device.Name,
      pac: device.PAC,

      certificate: device.certificate,
    };
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/devices",
      "",
      JSON.stringify(body),
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    headers["Content-Type"] = "application/json";
    return new NetworkRequestDescriptor(
      "HTTP",
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/devices",
      headers,
      "",
      body
    );
  }

  //New function to update the list of user which can access device data
  UpdateDeviceConfiguration(deviceId, sharedWithArray) {
    let bodyObj = {
      deviceId: deviceId,
      sharedWithArray: sharedWithArray,
    };
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "PUT",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/devices/" +
        deviceId,
      "",
      JSON.stringify(bodyObj),
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "PUT",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/devices/" +
        deviceId,
      headers,
      "",
      bodyObj
    );
  }

  /*
    UpdateDeviceConfiguration(deviceId,model){
        let configuration = {}
        let attributes = {}
        for(let key in model){
            let keys = key.split(".")
            switch(keys[0])
            {
                case "configuration":
                    configuration[keys[1]] = model[key]
                    break
                case "attributes":
                    attributes[keys[1]] = model[key]
                    break
                default:
                    break
            }
        }


        let bodyObj = {
            deviceId: deviceId,
            configuration: configuration,
            attributes: attributes
        }
        let credentials = this.context.authentication.Credentials()
        let headers = this.sigv4.SignAsHTTPHeaders(
            'PUT', 
            this.settings.http[this.settings.env].host,
            '/'+this.settings.http[this.settings.env].basePath+'/devices/'+deviceId,
            '',
            JSON.stringify(bodyObj),
            this.settings.http[this.settings.env].service,
            this.settings.http[this.settings.env].region,
            credentials.accessKeyId,
            credentials.secretAccessKey,
            credentials.sessionToken
        )
        return new NetworkRequestDescriptor(
            'HTTP',
            'PUT', 
            this.settings.http[this.settings.env].host,
            '/'+this.settings.http[this.settings.env].basePath+'/devices/'+deviceId,
            headers,
            '',
            bodyObj
        )
    } 
        
    */

  GetDevices() {
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/devices",
      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/devices",
      headers,
      "",
      "",
      DeserializeDevices
    );
  }

  DeleteDevice(deviceId) {
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "DELETE",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/devices/" +
        deviceId,
      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "DELETE",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/devices/" +
        deviceId,
      headers,
      "",
      ""
    );
  }

  GetData(deviceIds, startTimeMillis, endTimeMillis, dataType) {
    let queryString = "";
    if (deviceIds) {
      deviceIds.sort();
      for (let i in deviceIds) {
        queryString = queryString + "devices=" + deviceIds[i] + "&";
      }
    }

    let serializer = null;
    let type = null;
    let streaming = null;
    switch (dataType) {
      case "telemetry":
        serializer = DeserializeTelemetryNew; // DeserializeTelemetry
        type = "telemetry";
        break;
      case "geolocation":
        serializer = DeserializeGeoLocationsNew; // DeserializeGeoLocations
        type = "geolocation";
        break;
      case "events":
        serializer = DeserializeEventsNew; //DeserializeEvents
        type = "events";
        break;
      case "raw":
        serializer = DeserializeRawDataNew;
        type = "raw";
        streaming = true;
        break;
      default:
        throw "Data type " + dataType + " unknown";
    }

    queryString = queryString + "timestampEnd=" + endTimeMillis + "&";
    queryString = queryString + "timestampStart=" + startTimeMillis + "&";
    queryString = queryString + "type=" + type;

    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/data",
      queryString,
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );

    return new NetworkRequestDescriptor(
      "HTTP",
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/data",
      headers,
      queryString,
      "",
      serializer,
      streaming
    );
  }

  StartListenRealtimeData() {
    let descriptors = [];

    let credentials = this.context.authentication.Credentials();

    let connectRequestUrl = this.sigv4.SignAsGenericQueryString(
      this.settings.mqtt[this.settings.env].protocol,
      this.settings.mqtt[this.settings.env].method,
      this.settings.mqtt[this.settings.env].host,
      this.settings.mqtt[this.settings.env].path,
      "",
      this.settings.mqtt[this.settings.env].service,
      this.settings.mqtt[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );

    descriptors.push(
      new NetworkRequestDescriptor(
        "MQTT",
        "CONNECT",
        connectRequestUrl,
        "",
        "",
        null,
        null,
        null
      )
    );
    descriptors.push(
      new NetworkRequestDescriptor(
        "MQTT",
        "SUBSCRIBE",
        null,
        //'atr/'+credentials.principalId+'/data',
        "atr/" + credentials.sub + "/data",
        null,
        null,
        null,
        DeserializeMessage
      )
    );
    // descriptors.push(
    //     new NetworkRequestDescriptor(
    //         'MQTT',
    //         'SUBSCRIBE',
    //         null,
    //         credentials.principalId+'/configuration',
    //         null,
    //         null,
    //         null,
    //         DeserializeMessage
    //     )
    // )
    return descriptors;
  }

  StopListenRealtimeData() {
    return new NetworkRequestDescriptor(
      "MQTT",
      "CLOSE",
      null,
      null,
      null,
      null,
      null
    );
  }

  GetApiKeys() {
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/apikeys",
      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/apikeys",
      headers,
      "",
      "",
      DeserializeApiKeys
    );
  }

  AddApiKey(apiKey) {
    let body = {
      label: apiKey.name,
    };
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/apikeys",
      "",
      JSON.stringify(body),
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    headers["Content-Type"] = "application/json";
    return new NetworkRequestDescriptor(
      "HTTP",
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/apikeys",
      headers,
      "",
      body
    );
  }

  UpdateApiKey(apiKey) {
    let body = {
      label: apiKey.name,
      enabled: apiKey.enabled,
    };
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "PUT",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/apikeys/" +
        apiKey.value.split(".")[1],
      "",
      JSON.stringify(body),
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    headers["Content-Type"] = "application/json";

    return new NetworkRequestDescriptor(
      "HTTP",
      "PUT",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/apikeys/" +
        apiKey.value.split(".")[1],
      headers,
      "",
      body
    );
  }

  DeleteApiKey(apiKey) {
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "DELETE",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/apikeys/" +
        apiKey.value.split(".")[1],
      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "DELETE",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/apikeys/" +
        apiKey.value.split(".")[1],
      headers,
      "",
      ""
    );
  }

  // Add here geofence APIs
  CreatePerimeter(perimeter) {
    let body = {
      perimeter: perimeter,
    };
    let credentials = this.context.authentication.Credentials();
    // window.console.log("credentials", credentials)
    let headers = this.sigv4.SignAsHTTPHeaders(
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/perimeters",
      "",
      JSON.stringify(body),
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    headers["Content-Type"] = "application/json";
    return new NetworkRequestDescriptor(
      "HTTP",
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/perimeters",
      headers,
      "",
      body
    );
  }

  GetPerimeter(deviceId) {
    let credentials = this.context.authentication.Credentials();
    // window.console.log("deviceId: ", deviceId)
    let headers = this.sigv4.SignAsHTTPHeaders(
      "GET",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/perimeters/" +
        deviceId,
      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "GET",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/perimeters/" +
        deviceId,
      headers,
      "",
      ""
    );
  }

  GetDataConverters() {
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/dataconverters",
      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/dataconverters",
      headers,
      "",
      "",
      DeserializeDataConverters
    );
  }

  GetDeviceProfiles(defaultProfiles) {
    let credentials = this.context.authentication.Credentials();
    let queryString = defaultProfiles ? "default_profiles=true" : "";
    let headers = this.sigv4.SignAsHTTPHeaders(
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/deviceprofiles",
      queryString,
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "GET",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/deviceprofiles",
      headers,
      queryString,
      "",
      DeserializeDeviceProfiles
    );
  }

  AddDeviceProfile(deviceProfile) {
    let id = deviceProfile.id;
    let technology = deviceProfile.technology;
    let converter = deviceProfile.converter;
    delete deviceProfile.id;
    delete deviceProfile.technology;
    delete deviceProfile.converter;
    let body = {
      id: id,
      technology: technology,
      context: {
        apikey:
          "NNSXS.GI5ZKPKYCQCYPWB5BF474MINQWIF7EK35YIUXYQ.AENMTW26VWV5GYMPEYEZUVG7264FHDV2AHLLFT5CCZHM6I2O46VQ", //deviceProfile.apikey,
        dsh_api_key: "esempio",
        region: "eu1", //deviceProfile.region
        application_key: "0000000000000000",
      },
      //context: deviceProfile,
      converter: converter,
    };

    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/deviceprofiles",
      "",
      JSON.stringify(body),
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    headers["Content-Type"] = "application/json";
    return new NetworkRequestDescriptor(
      "HTTP",
      "POST",
      this.settings.http[this.settings.env].host,
      "/" + this.settings.http[this.settings.env].basePath + "/deviceprofiles",
      headers,
      "",
      body
    );
  }

  DeleteDeviceProfile(deviceProfile) {
    let credentials = this.context.authentication.Credentials();
    let headers = this.sigv4.SignAsHTTPHeaders(
      "DELETE",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/deviceprofiles/" +
        deviceProfile.id,

      "",
      "",
      this.settings.http[this.settings.env].service,
      this.settings.http[this.settings.env].region,
      credentials.accessKeyId,
      credentials.secretAccessKey,
      credentials.sessionToken
    );
    return new NetworkRequestDescriptor(
      "HTTP",
      "DELETE",
      this.settings.http[this.settings.env].host,
      "/" +
        this.settings.http[this.settings.env].basePath +
        "/deviceprofiles/" +
        deviceProfile.id,
      headers,
      "",
      ""
    );
  }
}

function DeserializeApiKeys(rawApiKeys) {
  return rawApiKeys.map((rawApiKey) => DeserializeApiKey(rawApiKey));
}

function DeserializeApiKey(rawApiKey) {
  return new ApiKey(
    rawApiKey.label,
    rawApiKey.owner + "." + rawApiKey.apikey,
    new Date(rawApiKey.create_timestamp),
    rawApiKey.enabled,
    new Date(rawApiKey.enabled_update_timestamp)
  );
}

function DeserializeDataConverters(rawDataConverters) {
  return rawDataConverters.map((rawDataConverter) =>
    DeserializeDataConverter(rawDataConverter)
  );
}

function DeserializeDataConverter(rawDataConverter) {
  return new DataConverter(
    rawDataConverter.id,
    rawDataConverter.label,
    new Date(rawDataConverter.create_timestamp),
    new Date(rawDataConverter.update_timestamp),
    rawDataConverter.converter
  );
}

function DeserializeDeviceProfiles(rawDeviceProfiles) {
  return rawDeviceProfiles.map((rawDeviceProfile) =>
    DeserializeDeviceProfile(rawDeviceProfile)
  );
}

function DeserializeDeviceProfile(rawDeviceProfile) {
  return new DeviceProfile(
    rawDeviceProfile.id,
    new Date(rawDeviceProfile.create_timestamp),
    rawDeviceProfile.technology,
    rawDeviceProfile.context,
    rawDeviceProfile.converter
  );
}

function DeserializeMessage(message) {
  message = JSON.parse(message.payload);

  switch (message.type) {
    case "configuration":
      return {
        metadata: message.type,
        payload: {configuration: DeserializeDevices([message])[0]},
      };
    default:
      return {
        metadata: "telemetry",
        payload: {
          telemetry: DeserializeTelemetryNew([message]),
          geolocation: DeserializeGeoLocationsNew([message]),
          events: DeserializeEventsNew([message]),
        },
      };
  }

  // switch(message.type){
  //     case "configuration":
  //         return {
  //             metadata: message.type,
  //             payload: DeserializeDevices([message])[0]
  //         }
  //     case "telemetry":
  //         return {
  //             metadata: message.type,
  //             payload:  DeserializeTelemetryNew([message])//DeserializeTelemetry([message])
  //         }
  //     case "geolocation":
  //         return {
  //             metadata: message.type,
  //             payload: DeserializeGeoLocationsNew([message]) // DeserializeGeoLocations([message])
  //         }
  //     case "events":
  //         return {
  //             metadata: message.type,
  //             payload: DeserializeEventsNew([message]) // DeserializeEvents([message])
  //         }
  //     default:
  //         throw "Invalid message"
  // }
}

function DeserializeDevices(rawDevices) {
  let devices = [];
  rawDevices.forEach((rawDevice) => {
    if (rawDevice.device_id) rawDevice.id = rawDevice.device_id;
    if (rawDevice.attributes) {
      rawDevice.attributes.customName = rawDevice.attributes.label;

      rawDevice.attributes.technologyImage = resourcesResolver(
        "technology",
        rawDevice.attributes.technology
      );
    }
    rawDevice.configuration_signaled = rawDevice.configuration_signaled
      ? rawDevice.configuration_signaled
      : {};
    if (!rawDevice.configuration_signaled.measures)
      rawDevice.configuration_signaled.measures = [
        {
          id: "tem",
          label: "Temperature",
          unit: {
            value: 1,
            label: "°C",
          },
          scalar: true,
          img: resourcesResolver("telemetry", "temperature"),
        },
        {
          id: "pre",
          label: "Pressure",
          unit: {
            value: 1,
            label: "hPa",
          },
          scalar: true,
          img: resourcesResolver("telemetry", "pressure"),
        },
        {
          id: "hum",
          label: "Humidity",
          unit: {
            value: 1,
            label: "o/o",
          },
          scalar: true,
          img: resourcesResolver("telemetry", "humidity"),
        },
        {
          id: "acc",
          label: "Accelerometer",
          unit: {
            value: 0.001,
            label: "g",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          img: resourcesResolver("telemetry", "acc"),
        },
        {
          id: "gyr",
          label: "Gyroscope",
          unit: {
            value: 0.001,
            label: "dps",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          img: resourcesResolver("telemetry", "gyr"),
        },
        {
          id: "mag",
          label: "Magnetometer",
          unit: {
            value: 0.001,
            label: "gauss",
          },
          scalar: false,
          dimensions: ["x", "y", "z"],
          img: resourcesResolver("telemetry", "mag"),
        },
      ];
    else {
      let measuresArray = [];
      for (let i in rawDevice.configuration_signaled.measures) {
        let measure = rawDevice.configuration_signaled.measures[i];
        if (i.includes("measure_")) {
          let name = measure.getCaseInsensProp("Name");
          let label = name;
          let dimensions = measure.getCaseInsensProp("Dimensions");
          let labelUnit = measure.getCaseInsensProp("Units");
          let valueUnit = 1;

          switch (label.toLowerCase()) {
            case "gyr":
              label = "Gyroscope";
              break;
            case "acc":
              label = "Accelerometer";
              break;
            case "mag":
              label = "Magnetometer";
              break;
            default:
              break;
          }

          switch (labelUnit[0]) {
            case "m":
              valueUnit = 0.001;
              labelUnit = labelUnit.slice(1);
              break;
            case "h":
              valueUnit = 0.001;
              labelUnit = labelUnit.slice(1);
              break;
            case "u":
              valueUnit = 0.000001;
              labelUnit = labelUnit.slice(1);
              break;
            default:
              break;
          }
          if (Array.isArray(dimensions))
            for (let idim in dimensions)
              dimensions[idim] = dimensions[idim].toLowerCase();
          let unit = {
            value: valueUnit,
            label: labelUnit,
          };
          measuresArray.push({
            id: name,
            label: label,
            unit: unit,
            scalar: dimensions ? false : true,
            dimensions: dimensions,
            img: resourcesResolver("telemetry", name),
          });
        }
      }
      rawDevice.configuration_signaled.measures = measuresArray;
    }

    if (rawDevice.configuration_signaled.data)
      if (rawDevice.configuration_signaled.data.telemetry) {
        rawDevice.configuration_signaled.data.telemetry.forEach((d) => {
          let measure = rawDevice.configuration_signaled.measures.find(
            (m) => m.id == d.t
          );
          if (measure) d.img = measure.img;
        });
      }

    devices.push(
      new Device(
        rawDevice.id,
        rawDevice.attributes ? rawDevice.attributes : {},
        rawDevice.configuration ? rawDevice.configuration : {},
        rawDevice.configuration_signaled ? rawDevice.configuration_signaled : {}
      )
    );
  });
  return devices;
}

function DeserializeRawDataNew(data) {
  return data;
}

function DeserializeGeoLocationsNew(geoLocationObject) {
  let array = [];
  for (let i in geoLocationObject) {
    let deviceId = geoLocationObject[i].device_id;
    let values = geoLocationObject[i].values;
    let mapValues = [];
    let telemetry = [];
    values
      .filter((v) => v.t == "gnss")
      .forEach((v) => {
        if (!mapValues[v.ts]) mapValues[v.ts] = {};

        mapValues[v.ts].timestamp = new Date(v.ts);
        mapValues[v.ts]["latitude"] = v.v.lat;
        mapValues[v.ts]["longitude"] = v.v.lon;
        mapValues[v.ts]["altitude"] = v.v.ele;
      });
    for (let ts in mapValues) {
      telemetry.push(mapValues[ts]);
    }

    array.push({
      id: deviceId,
      data: telemetry,
    });
  }
  return array;
}

function DeserializeTelemetry(telemetryObject) {
  let array = [];

  let groupPerDevice = groupBy(
    telemetryObject.body ? telemetryObject.body : telemetryObject,
    "device_id"
  );
  for (let deviceId in groupPerDevice) {
    let telemetry = groupPerDevice[deviceId].map((data) => {
      let telemetryData = {
        timestamp: new Date(data.timestamp),
      };
      data.values.forEach((v) => (telemetryData[v.measure] = v.value));
      return telemetryData;
    });

    array.push({
      id: deviceId,
      data: telemetry,
    });
  }
  return array;
}

function DeserializeTelemetryNew(telemetryObject) {
  let array = [];

  for (let i in telemetryObject) {
    let deviceId = telemetryObject[i].device_id;
    let values = telemetryObject[i].values.filter((v) => v.t !== "evt");
    let mapValues = [];
    let telemetry = [];
    values.forEach((v) => {
      if (!mapValues[v.ts]) mapValues[v.ts] = {};

      mapValues[v.ts].timestamp = new Date(v.ts);
      mapValues[v.ts][v.t] = v.v;
      if (v.mtd) mapValues[v.ts].metadata = v.mtd;
    });
    for (let ts in mapValues) {
      telemetry.push(mapValues[ts]);
    }

    array.push({
      id: deviceId,
      data: telemetry,
    });
  }
  return array;
}

function DeserializeEvents(eventsObject) {
  let array = [];
  let groupPerDevice = groupBy(
    eventsObject.body ? eventsObject.body : eventsObject,
    "device_id"
  );
  for (let deviceId in groupPerDevice) {
    let deviceEvents = [];
    groupPerDevice[deviceId].forEach((es) => {
      deviceEvents.push({
        timestamp: new Date(es.timestamp),
        data: es.values,
      });
    });
    array.push({
      id: deviceId,
      data: deviceEvents,
    });
  }
  return array;
}

function DeserializeEventsNew(eventsObject) {
  let array = [];

  for (let i in eventsObject) {
    let deviceId = eventsObject[i].device_id;
    let values = eventsObject[i].values.filter((v) => v.t === "evt");
    let events = values.map((e) => {
      return {
        message: e.v.msg,
        timestamp: new Date(e.ts),
        id: deviceId,
        measure: e.v.m + (e.v.l ? " - " + e.v.l : ""),
        type: e.v.et,
      };
    });
    array.push({
      id: deviceId,
      data: events,
    });
  }

  return array;
}

function resourcesResolver(domain, name) {
  let img = null;
  if (name == null || name == undefined) return null;
  switch (domain.toLowerCase()) {
    case "telemetry":
      switch (name.toLowerCase()) {
        case "tem":
        case "temperature":
          img = require("@/assets/telemetry/tem.png");
          break;
        case "pre":
        case "pressure":
          img = require("@/assets/telemetry/pre.png");
          break;
        case "humidity":
          img = require("@/assets/telemetry/hum.svg");
          break;
        case "acc":
        case "accelerometer":
          img = require("@/assets/telemetry/acc.png");
          break;
        case "gyr":
        case "gyroscope":
          img = require("@/assets/telemetry/gyr.png");
          break;
        case "mag":
        case "magnetometer":
          img = require("@/assets/telemetry/mag.png");
          break;
      }
      break;
    case "technology":
      switch (name.toLowerCase()) {
        case "lora_ttn":
          img = {};
          img.image = require("@/assets/technology/lora.png");
          img.width = 4.5;
          img.marginLeft = -2;
          img.color = "#00838F";
          img.colorLight = "#B2EBF2";
          break;
        case "sigfox":
          img = {};
          img.image = require("@/assets/technology/sigfox.png");
          img.width = 4;
          img.style = "7rem;margin-top:0.5rem;";
          img.marginLeft = -2;
          img.color = "#5E35B1";
          img.colorLight = "#D1C4E9";
          break;
        case "nfc":
          img = {};
          img.image = require("@/assets/technology/nfc.png");
          img.width = 4;
          img.marginLeft = -2;
          img.color = "#2E7D32";
          img.colorLight = "#A5D6A7";
          break;
        case "ble":
        case "bluetooth":
          img = {};
          img.image = require("@/assets/technology/bluetooth.png");
          img.width = 1.5;
          img.marginLeft = -1;
          img.color = "#1976D2";
          img.colorLight = "#BBDEFB";
          break;
        case "wifi":
          img = {};
          img.image = require("@/assets/technology/wifi.png");
          img.width = 3;
          img.marginLeft = -1;
          img.color = "#616161";
          img.colorLight = "#F5F5F5";
          break;
        case "lte":
          img = {};
          img.image = require("@/assets/technology/lte.png");
          img.width = 2;
          img.marginLeft = -1;
          img.color = "#B71C1C";
          img.colorLight = "#FFCDD2";
          break;
        case "polaris":
          img = {};
          img.image = require("@/assets/technology/polaris.png");
          img.width = 5;
          img.marginLeft = -2;
          img.color = "#BDBDBD";
          img.colorLight = "#BDBDBD";
          break;
      }
      break;
    default:
      break;
  }
  return img;
}

function groupBy(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
